import { createFileRoute } from '@tanstack/react-router'
import { TestAIChat } from '../../../../components/TestAIChat'

export const Route = createFileRoute('/desa/$slug/dashboard/test-ai')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <TestAIChat desaId={desaId} />
  },
})
